import React from 'react';
import { string, number, array, bool } from 'prop-types';

import {
  StepperListItem,
  StepperListTitle,
  StepperListIcon,
  StepperStatusList,
  StepperStatusListWrapper,
} from './styles';

const STATUS_ENUM = {
  DONE: 0,
  CURRENT: 1,
  PENDING: 2,
};

const getStatusClasses = status => {
  if (status === STATUS_ENUM.CURRENT) {
    return 'CURRENT';
  } else if (status === STATUS_ENUM.DONE) {
    return 'DONE';
  }
  return 'PENDING';
};

StepperItem.propTypes = {
  status: number.isRequired,
  title: string.isRequired,
  applicantImages: array /* eslint-disable-line react/forbid-prop-types */,
  first: bool,
  last: bool,
};
StepperItem.defaultProps = {
  first: false,
  last: false,
  applicantImages: [],
};

const createStatusImages = (status, applicantImages, first, last) => {
  applicantImages = applicantImages || []; /* eslint-disable-line  */
  const stepperStatusList = [];
  applicantImages.forEach(applicantImage => {
    stepperStatusList.push(
      <StepperStatusList
        key={applicantImage}
        status={getStatusClasses(status)}
        url={applicantImage}
      />
    );
  });

  return (
    <StepperStatusListWrapper
      first={first}
      last={last}
      status={status}
      numberOfImages={applicantImages.length}>
      {stepperStatusList}
    </StepperStatusListWrapper>
  );
};

function StepperItem({ title, status, applicantImages, first, last }) {
  return (
    <StepperListItem status={getStatusClasses(status)}>
      {createStatusImages(status, applicantImages, first, last)}
      <StepperListIcon status={getStatusClasses(status)} />
      <StepperListTitle>{title}</StepperListTitle>
    </StepperListItem>
  );
}

export default StepperItem;



// WEBPACK FOOTER //
// ./src/components/Stepper/StepperItem.js